/* eslint-disable */
import {
  Box,
  Button,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import React, { useCallback, useState } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import api, {
  authHeader,
} from '../../../../../../../../services/API/apiConfig';
import { DialogBox } from '../../../../../../../components/singleComponents/dialogs/DialogBox';
import { CopyBudgetModal } from './components/EditingTable/components/CopyBudgetModal';
import { EditingTable } from './components/EditingTable/EditingTable';
import { useTableDataContext } from './context/EditingTableDataContext';
import {
  ButtonsAndInputContainer,
  Container,
  HeaderContainer,
  IconButtonContainer,
  TitleContainer,
} from './styles';
import ToasterBox from '../../../../../../../components/singleComponents/toaster/ToasterBox';

export const EditBudgetV2 = () => {
  const {
    allTableDataWithExtraInfo,
    tableHasDataFromFirstLayer,
    updateTableData,
    initialData,
    setToaster,
    toaster,
  } = useTableDataContext();

  const navigate = useNavigate();

  const [isCopyBudgetModalOpen, setIsCopyBudgetModalOpen] = useState(false);
  const [isDeleteBudgetDialogOpen, setIsDeleteBudgetDialogOpen] =
    useState(false);
  const [isGoBackDialogOpen, setIsGoBackDialogOpen] = useState(false);

  const [constructionsToCopyBudget, setConstructionsToCopyBudget] = useState(
    []
  );
  const [budgetIDToCopy, setBudgetIDToCopy] = useState('');

  const handleOpenDeleteBudgetModal = useCallback(
    () => setIsDeleteBudgetDialogOpen(true),
    []
  );
  const handleCloseDeleteBudgetModal = useCallback(
    () => setIsDeleteBudgetDialogOpen(false),
    []
  );

  const handleOpenGoBackDialog = useCallback(
    () => setIsGoBackDialogOpen(true),
    []
  );
  const handleCloseGoBackDialog = useCallback(
    () => setIsGoBackDialogOpen(false),
    []
  );
  const handleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleOpenCopyBudgetModal = useCallback(() => {
    // seta os itens a serem escolhidos para importar um novo orçamento.
    api
      .get('/constructions', {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        return Promise.all(
          data.map(({ id }) =>
            api
              .get(`constructions/${id}/budgets`, {
                headers: authHeader(),
              })
              .then((response) => {
                if (response.data.data.length === 0) {
                  return { items_attributes: [] };
                }
                return {
                  ...response.data.data,
                  name: response.data.data.construction,
                  id: data.find(
                    (d) => d.name === response.data.data.construction
                  ).id,
                };
              })
          )
        );
      })
      .then((res) => {
        const constructionsWithBudgets = res.filter(
          (construction) => construction.items_attributes.length
        );
        setConstructionsToCopyBudget(constructionsWithBudgets);
        handleCloseDeleteBudgetModal();
        setIsCopyBudgetModalOpen(true);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err.response.data);
      });
  }, [handleCloseDeleteBudgetModal]);
  const handleCloseCopyBudgetModal = useCallback(
    () => setIsCopyBudgetModalOpen(false),
    []
  );

  const handleCopyBudgetChange = useCallback((event) => {
    setBudgetIDToCopy(event.target.value);
  }, []);

  const handleClearBudget = useCallback(() => {
    handleCloseDeleteBudgetModal();
    updateTableData({ ...allTableDataWithExtraInfo, items_attributes: [] });
  }, [
    allTableDataWithExtraInfo,
    handleCloseDeleteBudgetModal,
    updateTableData,
  ]);

  const handleImportNewBudget = useCallback(
    (copyBudgetWithPrices) => {
      if (budgetIDToCopy === '0') {
        api
          .get('/budget_templates/1', {
            headers: authHeader(),
          })
          .then((res) => {
            updateTableData({
              ...allTableDataWithExtraInfo,
              items_attributes: res.data.data.data.items_attributes.map((item) => ({
                item_num: item.item_num,
                description: item.description,
                unit: item.unit,
                quantity: '',
                unit_price: 0,
                price: 0,
                items_attributes: item.items_attributes.map((subItem) => ({
                  item_num: subItem.item_num,
                  description: subItem.description,
                  items_attributes: subItem.items_attributes.map(
                    (secondSubItem) => ({
                      item_num: secondSubItem.item_num,
                      description: secondSubItem.description,
                      unit: secondSubItem.unit,
                      quantity: '',
                      unit_price: 0,
                      price: 0,
                    })
                  ),
                  unit: subItem.unit,
                  quantity: '',
                  unit_price: 0,
                  price: 0,
                })),
              })),
            });
            handleCloseCopyBudgetModal();
            setConstructionsToCopyBudget([]);
          });
      } else {
        api
          .get(`constructions/${budgetIDToCopy}/budgets`, {
            headers: authHeader(),
          })
          .then((res) => {
            const { data } = res.data;
            if (data.items_attributes !== undefined) {
              const budgetCopied = data.items_attributes.map((item) => {
                const newItem = {
                  item_num: item.item_num,
                  description: item.description,
                  unit: item.unit,
                  quantity: copyBudgetWithPrices ? String(item.quantity) : '',
                  unit_price: copyBudgetWithPrices ? item.unit_price : 0,
                  price: copyBudgetWithPrices ? item.price : 0,
                  items_attributes: item.items_attributes.map((subItem) => ({
                    item_num: subItem.item_num,
                    description: subItem.description,
                    items_attributes: subItem.items_attributes.map(
                      (secondSubItem) => ({
                        item_num: secondSubItem.item_num,
                        description: secondSubItem.description,
                        unit: secondSubItem.unit,
                        quantity: copyBudgetWithPrices
                          ? String(secondSubItem.quantity)
                          : '',
                        unit_price: copyBudgetWithPrices
                          ? secondSubItem.unit_price
                          : 0,
                        price: copyBudgetWithPrices ? secondSubItem.price : 0,
                      })
                    ),
                    unit: subItem.unit,
                    quantity: copyBudgetWithPrices
                      ? String(subItem.quantity)
                      : '',
                    unit_price: copyBudgetWithPrices ? subItem.unit_price : 0,
                    price: copyBudgetWithPrices ? subItem.price : 0,
                  })),
                };
  
                return newItem;
              });
  
              updateTableData({
                ...allTableDataWithExtraInfo,
                items_attributes: budgetCopied,
              });
              handleCloseCopyBudgetModal();
              setConstructionsToCopyBudget([]);
            }
          });
      }
    },
    [
      allTableDataWithExtraInfo,
      budgetIDToCopy,
      handleCloseCopyBudgetModal,
      updateTableData,
    ]
  );

  const checkMissingDescription = useCallback(
    ({ itemsArray, layer, path = '' }) =>
      itemsArray.some((item, index) => {
        const currentPath = path ? `${path}.${index + 1}` : `${index + 1}`;

        if (!item.description || item.description.trim() === '') {
          // TODO: criar um componente de toast para exibir mensagens de erro padronizadas
          // o classname é temporario, favor, considerar a criação de um componente de toast e discussão sobre a padronização de mensagens de erro
          setToaster({
            open: true,
            msg: `Descrição faltando no item ${currentPath}`,
          });
          setTimeout(() => setToaster({ open: false, msg: '' }), 3000);
          return true;
        }

        if (item.items_attributes && item.items_attributes.length > 0) {
          return checkMissingDescription({
            itemsArray: item.items_attributes,
            layer: layer + 1,
            path: currentPath,
          });
        }

        return false;
      }),
    []
  );

  const handleFormSubmit = useCallback(
    (event) => {
      event.preventDefault();

      const missingDescriptionAnyLayer = checkMissingDescription({
        itemsArray: allTableDataWithExtraInfo.items_attributes,
        layer: 1,
      });

      if (!missingDescriptionAnyLayer) {
        const data = {
          budget: {
            square_meters: parseInt(
              allTableDataWithExtraInfo.square_meters,
              10
            ),
            items_attributes: allTableDataWithExtraInfo.items_attributes,
          },
        };
        api
          .patch(`/budgets/${allTableDataWithExtraInfo.id}`, data, {
            headers: authHeader(),
          })
          .then((res) => {
            if (res.data.status === 0) {
              // TODO: criar um componente de toast para exibir mensagens de erro padronizadas
              // o classname é temporario, favor, considerar a criação de um componente de toast e discussão sobre a padronização de mensagens de erros
              setToaster({ open: true, msg: 'Orçamento salvo com sucesso' });
              localStorage.removeItem('constructionId');
              localStorage.removeItem('copyWithValues');
              setTimeout(() => {
                handleGoBack();
              }, 1500);
            } else {
              // TODO: criar um componente de toast para exibir mensagens de erro padronizadas
              // o classname é temporario, favor, considerar a criação de um componente de toast e discussão sobre a padronização de mensagens de erro
              setToaster({ open: true, msg: 'Erro ao salvar orçamento' });
            }
          })
          .catch((err) => {
            // TODO: criar um componente de toast para exibir mensagens de erro padronizadas
            // o classname é temporario, favor, considerar a criação de um componente de toast e discussão sobre a padronização de mensagens de erro
            setToaster({ open: true, msg: 'Erro ao salvar orçamento' });
          })
          .finally(() => {
            setTimeout(() => setToaster({ open: false, msg: '' }), 1500);
          });
      }
    },
    [
      allTableDataWithExtraInfo.id,
      allTableDataWithExtraInfo.items_attributes,
      allTableDataWithExtraInfo.square_meters,
      checkMissingDescription,
      handleGoBack,
    ]
  );

  const areArraysEqual = (arr1, arr2) => {
    if (!arr1 || !arr2) return true;

    if (arr1.length !== arr2.length) return false;

    function deepEqual(val1, val2) {
      if (
        typeof val1 === 'object' &&
        val1 !== null &&
        typeof val2 === 'object' &&
        val2 !== null
      ) {
        if (Array.isArray(val1) && Array.isArray(val2)) {
          return areArraysEqual(val1, val2);
        }
        return areObjectsEqual(val1, val2);
      } else {
        return val1 == val2;
      }
    }

    function areObjectsEqual(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) return false;

      for (let key of keys1) {
        if (!deepEqual(obj1[key], obj2[key])) return false;
      }

      return true;
    }

    for (let i = 0; i < arr1.length; i += 1) {
      if (!areObjectsEqual(arr1[i], arr2[i])) return false;
    }

    return true;
  };

  return (
    <Container>
      {toaster.open && <ToasterBox message={toaster.msg} showSeconds={5} />}
      <HeaderContainer>
        <IconButtonContainer
          onClick={() => {
            areArraysEqual(
              initialData?.items_attributes,
              allTableDataWithExtraInfo?.items_attributes
            )
              ? navigate(-1)
              : handleOpenGoBackDialog();
          }}
          style={{
            padding: 0,
          }}
        >
          <MdArrowBack size={42} color="#000" />
        </IconButtonContainer>
        <TitleContainer>
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            Editar Orçamento
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'left' }}>
            {allTableDataWithExtraInfo.construction}
          </Typography>
        </TitleContainer>
      </HeaderContainer>

      <ButtonsAndInputContainer>
        <TextField
          label="m² da obra"
          variant="outlined"
          slotProps={{
            inputLabel: { shrink: true },
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">m²</InputAdornment>,
          }}
          onChange={(e) =>
            updateTableData({
              ...allTableDataWithExtraInfo,
              square_meters: e.target.value,
            })
          }
          style={{ marginLeft: '32px' }}
          value={allTableDataWithExtraInfo.square_meters}
        />
        <Box>
          <Button
            variant="outlined"
            color="primary"
            onClick={
              tableHasDataFromFirstLayer
                ? handleOpenDeleteBudgetModal
                : handleOpenCopyBudgetModal
            }
            style={{ marginRight: '15px' }}
          >
            {tableHasDataFromFirstLayer
              ? 'Limpar orçamento'
              : 'Copiar Orçamento'}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleFormSubmit}
            style={{ color: 'white' }}
          >
            Salvar orçamento
          </Button>
        </Box>
      </ButtonsAndInputContainer>
      <Box
        style={{
          paddingLeft: '32px',
          marginTop: '50px',
          textAlign: tableHasDataFromFirstLayer.length ? '' : 'center',
        }}
      >
        <EditingTable />
      </Box>
      <CopyBudgetModal
        isCopyBudgetModalOpen={isCopyBudgetModalOpen}
        handleCloseCopyBudgetModal={handleCloseCopyBudgetModal}
        constructionsToCopyBudget={constructionsToCopyBudget}
        handleCopyBudgetChange={handleCopyBudgetChange}
        handleImportNewBudget={handleImportNewBudget}
        budgetIDToCopy={budgetIDToCopy}
      />
      <DialogBox
        title="Deletar Orçamento"
        content="Deseja realmente deletar este orçamento? Todas as informações serão perdidas."
        openDialog={isDeleteBudgetDialogOpen}
        closeDialog={handleCloseDeleteBudgetModal}
        mainAction={handleClearBudget}
      />
      <DialogBox
        title="Cancelar edição de orçamento"
        content="Deseja realmente cancelar a edição? Todas as informações inseridas serão perdidas."
        openDialog={isGoBackDialogOpen}
        closeDialog={handleCloseGoBackDialog}
        mainAction={() => handleGoBack()}
      />
    </Container>
  );
};
